module.exports = __webpack_public_path__ + "img/5.005b3674.png";